import React from 'react';
import { Check, Circle } from 'lucide-react';

const RULES = [
  { id: 'length',    label: 'At least 8 characters', test: (p) => p.length >= 8 },
  { id: 'lowercase', label: 'A lowercase letter',    test: (p) => /[a-z]/.test(p) },
  { id: 'uppercase', label: 'An uppercase letter',   test: (p) => /[A-Z]/.test(p) },
  { id: 'number',    label: 'A number',              test: (p) => /\d/.test(p) },
  { id: 'symbol',    label: 'A symbol (!@#$…)',      test: (p) => /[^A-Za-z0-9]/.test(p) },
];

/**
 * Renders a 5-rule checklist under a New Password input.
 * Each item turns green when satisfied. Renders nothing until the user types.
 */
const PasswordRequirements = ({ password, className = '' }) => {
  if (!password) return null;
  return (
    <ul
      className={`mt-2 grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-1 text-xs ${className}`}
      data-testid="password-requirements"
    >
      {RULES.map((rule) => {
        const ok = rule.test(password);
        return (
          <li
            key={rule.id}
            className={`flex items-center gap-1.5 ${ok ? 'text-emerald-600' : 'text-gray-500'}`}
            data-testid={`password-rule-${rule.id}`}
            data-ok={ok}
          >
            {ok ? <Check className="w-3.5 h-3.5 shrink-0" /> : <Circle className="w-3.5 h-3.5 shrink-0" />}
            <span className={ok ? 'line-through opacity-90' : ''}>{rule.label}</span>
          </li>
        );
      })}
    </ul>
  );
};

export default PasswordRequirements;
